import { ReactNode } from "react";
import { Text } from "components/text";
import { cn } from "utils";

export const ManuscriptProcessingRow = ({
  label,
  align = "center",
  children,
}: {
  label: string;
  align?: "center" | "start";
  children: ReactNode;
}) => (
  <div
    className={cn(
      "flex gap-3 border-b border-secondary-50 py-2.5 last:border-b-0",
      align === "start" ? "items-start" : "items-center",
    )}
  >
    <Text variant="muted" className="w-28 shrink-0">
      {label}
    </Text>
    {children}
  </div>
);
